import { MultiSelect, MultiSelectProps, SelectMode } from './multi-select';
import { DocumentDuplicateIcon } from '@heroicons/react/24/outline';
import type { TFunction } from 'i18next';
import { useTranslation } from 'react-i18next';

const options = (t: TFunction<'designSystem'>) => [
  { value: 'isCrownJewel', label: t('crownJewel') },
  {
    value: 'hasPersonallyIdentifiableInformation',
    label: t('personallyIdentifiableInformation'),
  },
  {
    value: 'hasPrivateHealthInformation',
    label: t('privateHealthInformation'),
  },
  {
    value: 'hasPaymentCardInformation',
    label: t('paymentCardInformation'),
  },
];
export const DataClassificationMultiSelect = ({
  icon,
  label,
  setValue,
  value,
  dataTestId,
  ...props
}: Omit<
  MultiSelectProps<ReturnType<typeof options>[number]>,
  'options' | 'mode' | 'label'
> &
  SelectMode & { label?: string }) => {
  const { t } = useTranslation('designSystem');
  return (
    <MultiSelect
      {...props}
      icon={icon || (DocumentDuplicateIcon as React.FC<{ className?: string }>)}
      label={label || t('dataClassifications')}
      options={options(t)}
      setValue={setValue as any}
      value={value as any}
      dataTestId={dataTestId}
    />
  );
};
